import React from 'react'

export const OpenClient = () => {
  return <React.Fragment>AUTH CLIENT</React.Fragment>
}
